module.exports = __webpack_public_path__ + "static/media/lock.3d6379d3.svg";